import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api/api";
import { toast } from "react-toastify";

export const ResetPassword = () => {
  const [pwd, setPwd] = useState("");
  const [cpwd, setCpwd] = useState("");
  const [show1, setShow1] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [show2, setShow2] = useState(false);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = params.get("email") || "";

  const handleReset = async (e) => {
    e.preventDefault();
    if (!pwd || !cpwd) return toast.warn("Please fill in both fields");
    if (pwd !== cpwd) return toast.warn("Passwords do not match");

    try {
      setSubmitting(true);
      await api.auth.setNewPassword(email, pwd);
      toast.warn("Password reset successful. Please login.");
      navigate("/reset-password/completed");
    } catch (err) {
      console.warn("Reset password failed:", err?.status, err?.message);
      toast.warn(err?.data?.message || "Failed to reset password. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] [font-family:'Nunito',Helvetica] text-[#5d4037]">
       
        <button
          type="button"
          aria-label="Go back"
          onClick={() => navigate(-1)}
          className="w-10 h-10 rounded-full bg-[#ccb357] grid place-items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>


        <h1 className="mt-4 text-center font-bold text-2xl leading-9">Reset password</h1>
        <p className="mt-2 w-[358px] mx-auto text-center font-medium text-base leading-6">
          Please type in something you can remember
        </p>

 
        <form onSubmit={handleReset} className="mt-10">

          <div className="w-[378px] mx-auto">
            <label className="block text-base font-semibold mb-3">Password</label>
            <div className="relative">
              <input
                type={show1 ? "text" : "password"}
                placeholder="Enter password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                className="w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] pl-[17px] pr-12 text-[#7a6f5c] text-base leading-[22px] outline-none"
              />
              <button
                type="button"
                aria-label={show1 ? "Hide password" : "Show password"}
                onClick={() => setShow1((v) => !v)}
                className="absolute right-4 top-1/2 -translate-y-1/2"
              >
                {show1 ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                    <path d="M3 3l18 18" />
                    <path d="M9.9 4.2A11 11 0 0 1 21 12s-4 7-11 7a11 11 0 0 1-6.1-2.1" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="w-[378px] mx-auto mt-6">
            <label className="block text-base font-semibold mb-3">Confirm Password</label>
            <div className="relative">
              <input
                type={show2 ? "text" : "password"}
                placeholder="Enter password"
                value={cpwd}
                onChange={(e) => setCpwd(e.target.value)}
                className="w-full h-[56px] bg-[#fff8e1] rounded-[18px] border border-[#5d4037] pl-[17px] pr-12 text-[#7a6f5c] text-base leading-[22px] outline-none"
              />
              <button
                type="button"
                aria-label={show2 ? "Hide password" : "Show password"}
                onClick={() => setShow2((v) => !v)}
                className="absolute right-4 top-1/2 -translate-y-1/2"
              >
                {show2 ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                    <path d="M3 3l18 18" />
                    <path d="M9.9 4.2A11 11 0 0 1 21 12s-4 7-11 7a11 11 0 0 1-6.1-2.1" />
                  </svg>
                )}
              </button>
            </div>
          </div>
       
          <div className="w-[378px] mx-auto">
            <button
              type="submit"
              disabled={submitting}
              className={`mt-12 w-full h-[60px] bg-[#f7c945] rounded-[50px] font-bold text-base text-[#5d4037] transition-opacity ${
                submitting ? "opacity-60 cursor-not-allowed" : "hover:opacity-90"
              }`}
            >
              {submitting ? "Resetting..." : "Reset Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
